export const TRIAGE_LEVEL = {
  no_risk: {
    riskTestInformation: 'PRZESTRZEGAJ PROFILAKTYKI'
  },
  self_monitoring: {
    riskTestInformation:
      'SAMOOBSERWACJA - POZOSTAŃ W DOMU I MONITORUJ STAN ZDROWIA'
  },
  quarantine: {
    riskTestInformation:
      'ODOSOBNIENIE DOMOWE. UNIKAJ KONTAKTU Z DOMOWNIKAMI. OBSERWUJ SWÓJ STAN ZDROWIA.'
  },
  isolation_call: {
    riskTestInformation:
      'IZOLACJA DOMOWA. UNIKAJ KONTAKTU Z DOMOWNIKAMI. SKONSULTUJ SIĘ Z NUMEREM ALARMOWYM.'
  },
  isolation_ambulance: {
    riskTestInformation:
      'BEZWZGLĘDNIE NIE OPUSZCZAJ DOMU. ZABRONIONY KONTAKT Z INNYMI LUDŹMI/DOMOWNIKAMI. OBOWIĄZKOWY KONTAKT Z NUMEREM ALARMOWYM.'
  },
  call_doctor: {
    riskTestInformation:
      'TWOJE OBJAWY SĄ NIEPOKOJĄCE, SKONSULTUJ SIĘ Z LEKARZEM.'
  }
};
